export default function (ary1, ary2) {
  return ary1.concat(ary2);
}
